class ViewMoreController {
    constructor($sce) {
        this.$sce = $sce;
    }

    $onInit() {
        if (this.charCount < this.fullText.length) {
            this.isExpanded = false;
            this.displayText = this.$sce.trustAsHtml(`${this.fullText.slice(0, this.charCount)} ...`);
        }

        this.fullTextValue = this.$sce.trustAsHtml(this.fullText);
    }
}

const viewMoreComponentDefinition = {
    bindings: {
        charCount: '=',
        fullText: '=',
    },
    controller: ['$sce', ViewMoreController],
    template: require('./viewmore.component.html').trim(),
};

module.exports = {
    ViewMoreController,
    viewMoreComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/viewmore/viewmore.component.js